import {computed, decorate, observable} from 'mobx';
import {maxBy} from 'lodash';
import {faHdd} from '@fortawesome/pro-solid-svg-icons';
import {BaseModel as Hierarchy, BaseModel} from './base';

export class Workplace extends BaseModel {
  static faIcon = faHdd;

  searchableProperties = ['no', 'name'];
  saveableProperties = [
    'no',
    'name',
    'info',
    'hierarchyId',
    'groupId',
    'isVirtualRoot',
    'properties',
    'disableYieldReporting',
    'terminalLayoutId',
  ];
  actualPersonnelLogs = [];

  populateAttributesFromStore(rootStore) {
    super.populateAttributesFromStore(rootStore);

    this.group = rootStore.workplaceGroupStore.getById(this.groupId);
    this.hierarchy = Hierarchy.findInTree(rootStore.hierarchyStore.hierarchies, this.hierarchyId);
    this.actualPersonnelLogs = rootStore.personnelLogStore.personnelLogs.filter((log) => log.workplaceId === this.id);
    this.terminalLayout = rootStore.terminalLayoutsStore.getById(this.terminalLayoutId);
  }

  static prepareApiPayload(model) {
    return {
      id: model.id || undefined,
      no: model.no || null,
      name: model.name || null,
      info: model.info || null,
      isVirtualRoot: model.isVirtualRoot || null,
      properties: model.properties || null,
      groupId: model.groupId || null,
      hierarchyId: model.hierarchyId || null,
      terminalLayoutId: model.terminalLayoutId || null,
      disableYieldReporting: model.disableYieldReporting || null,
    };
  }

  get actualPersonnel() {
    return maxBy(this.actualPersonnelLogs, 'createdAt')?.personnel;
  }

  get label() {
    return `${this.no} (${this.name})`;
  }
}

decorate(Workplace, {
  id: observable,
  no: observable,
  name: observable,
  info: observable,
  hierarchy: observable,
  hierarchyId: observable,
  group: observable,
  groupId: observable,
  isVirtualRoot: observable,
  actualPersonnelLogs: observable,
  actualPersonnel: computed,
  relevantDocuments: observable,
  terminalLayoutId: observable,
  terminalLayout: observable,
  disableYieldReporting: observable,
  createdAt: observable,
  createdBy: observable,
  updatedAt: observable,
  updatedBy: observable,
  deletedAt: observable,
  deletedBy: observable,
  createdByUser: observable,
  updatedByUser: observable,
});
